module.exports = __webpack_public_path__ + "267f625e0e8135ddfd1239fae288fdab.png";